/**
 * Indian real-estate area unit catalogue.
 *
 * Units are grouped by region so a seller from Bengal/Bihar/Punjab
 * finds their preferred unit at the top of the list, but universal
 * SI + imperial units are always available. Conversion factor is to
 * square feet, so downstream code can normalise if needed.
 */

export const AREA_UNITS = [
  // Universal
  { value: 'sqft', label: 'Sq ft (Square feet)', group: 'Universal', to_sqft: 1 },
  { value: 'sqm', label: 'Sq m (Square meter)', group: 'Universal', to_sqft: 10.7639 },
  { value: 'sqyd', label: 'Sq yard / Gaj', group: 'Universal', to_sqft: 9 },
  { value: 'acre', label: 'Acre', group: 'Universal', to_sqft: 43560 },
  { value: 'hectare', label: 'Hectare', group: 'Universal', to_sqft: 107639 },

  // Bengal / Bihar / Assam
  { value: 'bigha_bengal', label: 'Bigha (Bengal / Bihar — 14,400 sqft)', group: 'Bengal / Bihar', to_sqft: 14400 },
  { value: 'katha_bengal', label: 'Katha (Bengal — 720 sqft)', group: 'Bengal / Bihar', to_sqft: 720 },
  { value: 'katha_bihar', label: 'Katha (Bihar — 1,361 sqft)', group: 'Bengal / Bihar', to_sqft: 1361 },
  { value: 'chatak', label: 'Chatak (Bengal — 45 sqft)', group: 'Bengal / Bihar', to_sqft: 45 },
  { value: 'lecha', label: 'Lecha (Assam — 144 sqft)', group: 'Bengal / Bihar', to_sqft: 144 },

  // UP / MP / Rajasthan
  { value: 'bigha_up', label: 'Bigha (UP / Uttarakhand — 27,000 sqft)', group: 'UP / MP / Rajasthan', to_sqft: 27000 },
  { value: 'bigha_mp', label: 'Bigha (MP / Rajasthan — 12,000 sqft)', group: 'UP / MP / Rajasthan', to_sqft: 12000 },
  { value: 'biswa_up', label: 'Biswa (UP — 1,350 sqft)', group: 'UP / MP / Rajasthan', to_sqft: 1350 },
  { value: 'nali', label: 'Nali (Uttarakhand — 2,160 sqft)', group: 'UP / MP / Rajasthan', to_sqft: 2160 },

  // Maharashtra / Karnataka / Gujarat
  { value: 'guntha', label: 'Guntha (Maharashtra / Karnataka — 1,089 sqft)', group: 'Maharashtra / Karnataka / Gujarat', to_sqft: 1089 },
  { value: 'are', label: 'Are (Maharashtra — 1,076 sqft)', group: 'Maharashtra / Karnataka / Gujarat', to_sqft: 1076 },
  { value: 'vigha_guj', label: 'Vigha (Gujarat — 17,424 sqft)', group: 'Maharashtra / Karnataka / Gujarat', to_sqft: 17424 },

  // Tamil Nadu / Kerala / Andhra
  { value: 'ground', label: 'Ground (Tamil Nadu — 2,400 sqft)', group: 'TN / Kerala / Andhra', to_sqft: 2400 },
  { value: 'cent', label: 'Cent (Kerala / TN — 435.6 sqft)', group: 'TN / Kerala / Andhra', to_sqft: 435.6 },
  { value: 'ankanam', label: 'Ankanam (Andhra — 72 sqft)', group: 'TN / Kerala / Andhra', to_sqft: 72 },

  // Punjab / Haryana / Himachal
  { value: 'marla', label: 'Marla (Punjab / Haryana — 272.25 sqft)', group: 'Punjab / Haryana / Himachal', to_sqft: 272.25 },
  { value: 'kanal', label: 'Kanal (Punjab / Haryana — 5,445 sqft)', group: 'Punjab / Haryana / Himachal', to_sqft: 5445 },
  { value: 'sarsahi', label: 'Sarsahi (Punjab — 30.25 sqft)', group: 'Punjab / Haryana / Himachal', to_sqft: 30.25 },
];

export const AREA_UNIT_MAP = Object.fromEntries(AREA_UNITS.map((u) => [u.value, u]));

export const AREA_UNIT_GROUPS = AREA_UNITS.reduce((acc, unit) => {
  (acc[unit.group] = acc[unit.group] || []).push(unit);
  return acc;
}, {});
